import { AI_TOUR } from './definitions/ai';
import { EXPLORE_TOUR } from './definitions/explore';
import type { TourDefinition } from './types';

/** Query param that starts a tour — announcements link to `/path?tour=<id>`. */
export const TOUR_PARAM = 'tour';

/**
 * Every tour, by id. Adding a tour = one file in ./definitions + one line here.
 * The engine never changes per feature.
 */
export const TOURS = Object.freeze({
  [EXPLORE_TOUR.id]: EXPLORE_TOUR,
  [AI_TOUR.id]: AI_TOUR,
} as const satisfies Record<string, TourDefinition>);

export type TourId = keyof typeof TOURS;

/** Unknown ids (typos, tours not deployed yet) resolve to null — callers no-op. */
export function getTour(id: string | null | undefined): TourDefinition | null {
  if (!id || !Object.hasOwn(TOURS, id)) return null;
  return TOURS[id as TourId];
}
